export enum ReportDataType {
  object = "object",
  string = "string",
  boolean = "boolean",
  array = "array",
  number = "number"
}
